// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.navg{
  background: rgba(white, 0.4);
}

.astyle{
    padding: 8px;
    color: white;
    font-size: 10px;
   
}

.subnav{
    background: rgba(white, 0.4);
}

  .dropdown {
    display: inline-block;
    position: relative;
  }
  
  button{
    border:none;
    border-radius:5px;
    color: white;
    font-size: 11px;
    font-weight: 600;
   
    cursor:pointer;
    border: none;
    background-color: transparent;
  }
  
  
  .dropdown-options {
    display: none;
    position: absolute !important;
    overflow: auto;
    background-color:#fff;
    border-radius:5px;
    box-shadow: 0px 10px 10px 0px rgba(0,0,0,0.4);
    z-index: 5;
    width: 15rem;
  }
  
  .dropdown:hover .dropdown-options {
    display: block;
  }
  
  .dropdown-options a {
    display: block;
    color: #000000;
    padding: 5px; 
    text-decoration: none;
    padding:20px 40px;
  }
  
  .dropdown-options a:hover {
    color: #0a0a23;
    background-color: #ddd;
    border-radius:5px;
  }
  .img-fluid{
    max-width: 100%;
    height: auto;
    /* this need to change */
     
  }



  .dashclass{
    border:none;
    border-radius:5px;
    color: white;
    font-size: 23px;
    font-weight: bolder;
    padding:  1px 1rem 1px 1rem;
    cursor:pointer;
    border: none;
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
    background-color: transparent;
  }
  .astyle{
    text-decoration: none;
    font-size: 15px;
    font-weight: bold;
  }
  .tabsbutton{
    border: 1px solid transparent;
    border-radius: 4px 4px 0 0;
    color: black;
    font-size:unset
  }
  .tabsbutton:hover{
    background-color: #2d348e !important;
    color: white !important;
  }
  .icon {
    padding-left: 25px;
    background: url(https://softmategroup.com/assets/images/My_Dashboard/Search.png) no-repeat left;
    background-size: 34px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 2rem;
    width: 1rem;
  }
  .liststyle{
    border: none;
    padding: 0;
    padding-left: 1rem;
    font-size: 12px;
    font-weight: 700;
    background-color: #fff2e9;
  }`, "",{"version":3,"sources":["webpack://./src/Components/Users/homepage.css"],"names":[],"mappings":";AACA;EACE,4BAA4B;AAC9B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;;AAEnB;;AAEA;IACI,4BAA4B;AAChC;;EAEE;IACE,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,gBAAgB;;IAEhB,cAAc;IACd,YAAY;IACZ,6BAA6B;EAC/B;;;EAGA;IACE,aAAa;IACb,6BAA6B;IAC7B,cAAc;IACd,qBAAqB;IACrB,iBAAiB;IACjB,6CAA6C;IAC7C,UAAU;IACV,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,cAAc;IACd,YAAY;IACZ,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,YAAY;IACZ,wBAAwB;;EAE1B;;;;EAIA;IACE,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,2BAA2B;IAC3B,cAAc;IACd,YAAY;IACZ,wEAAwE;IACxE,6BAA6B;EAC/B;EACA;IACE,qBAAqB;IACrB,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,6BAA6B;IAC7B,0BAA0B;IAC1B,YAAY;IACZ;EACF;EACA;IACE,oCAAoC;IACpC,uBAAuB;EACzB;EACA;IACE,kBAAkB;IAClB,+FAA+F;IAC/F,qBAAqB;IACrB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,WAAW;EACb;EACA;IACE,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;EAC3B","sourcesContent":["\r\n.navg{\r\n  background: rgba(white, 0.4);\r\n}\r\n\r\n.astyle{\r\n    padding: 8px;\r\n    color: white;\r\n    font-size: 10px;\r\n   \r\n}\r\n\r\n.subnav{\r\n    background: rgba(white, 0.4);\r\n}\r\n\r\n  .dropdown {\r\n    display: inline-block;\r\n    position: relative;\r\n  }\r\n  \r\n  button{\r\n    border:none;\r\n    border-radius:5px;\r\n    color: white;\r\n    font-size: 11px;\r\n    font-weight: 600;\r\n   \r\n    cursor:pointer;\r\n    border: none;\r\n    background-color: transparent;\r\n  }\r\n  \r\n  \r\n  .dropdown-options {\r\n    display: none;\r\n    position: absolute !important;\r\n    overflow: auto;\r\n    background-color:#fff;\r\n    border-radius:5px;\r\n    box-shadow: 0px 10px 10px 0px rgba(0,0,0,0.4);\r\n    z-index: 5;\r\n    width: 15rem;\r\n  }\r\n  \r\n  .dropdown:hover .dropdown-options {\r\n    display: block;\r\n  }\r\n  \r\n  .dropdown-options a {\r\n    display: block;\r\n    color: #000000;\r\n    padding: 5px; \r\n    text-decoration: none;\r\n    padding:20px 40px;\r\n  }\r\n  \r\n  .dropdown-options a:hover {\r\n    color: #0a0a23;\r\n    background-color: #ddd;\r\n    border-radius:5px;\r\n  }\r\n  .img-fluid{\r\n    max-width: 100%;\r\n    height: auto;\r\n    /* this need to change */\r\n     \r\n  }\r\n\r\n\r\n\r\n  .dashclass{\r\n    border:none;\r\n    border-radius:5px;\r\n    color: white;\r\n    font-size: 23px;\r\n    font-weight: bolder;\r\n    padding:  1px 1rem 1px 1rem;\r\n    cursor:pointer;\r\n    border: none;\r\n    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;\r\n    background-color: transparent;\r\n  }\r\n  .astyle{\r\n    text-decoration: none;\r\n    font-size: 15px;\r\n    font-weight: bold;\r\n  }\r\n  .tabsbutton{\r\n    border: 1px solid transparent;\r\n    border-radius: 4px 4px 0 0;\r\n    color: black;\r\n    font-size:unset\r\n  }\r\n  .tabsbutton:hover{\r\n    background-color: #2d348e !important;\r\n    color: white !important;\r\n  }\r\n  .icon {\r\n    padding-left: 25px;\r\n    background: url(https://softmategroup.com/assets/images/My_Dashboard/Search.png) no-repeat left;\r\n    background-size: 34px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 2rem;\r\n    width: 1rem;\r\n  }\r\n  .liststyle{\r\n    border: none;\r\n    padding: 0;\r\n    padding-left: 1rem;\r\n    font-size: 12px;\r\n    font-weight: 700;\r\n    background-color: #fff2e9;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
